var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapBasic',{attrs:{"circles":_vm.circles,"loading-data":_vm.loading,"markers":_vm.markerList,"polygons":_vm.polygons,"refreshCenterCount":_vm.refreshCenterCount,"disable-back-navigation":_vm.filterOpen}})}
var staticRenderFns = []

export { render, staticRenderFns }